module.exports = __webpack_public_path__ + "static/img/ShopReceipt_AdminShippop.cbb047fb.jpg";